module.exports = __webpack_public_path__ + "assets/youtube-listview-icon.cf1a9b8c.svg";